<template>
  <div>
    <modal
      :is-visible="isVisible"
      :title="$t('c.invitationModal.title')"
      @close="closeModal"
    >
      <form-wrap @submit="handleSubmit">
        <form-field-set :should-show-border="false">
          <text-input
            v-model="emailAddresses"
            :error="fieldError(requestType, 'emailAddresses')"
            :label="$t('c.invitationModal.form.label.email_addresses')"
            name="emailAddresses"
            direction="vertical"
          />
          <switch-input
            v-model="role"
            :label="$t('c.invitationModal.form.label.role')"
            :label-visible="false"
            :hint="$t('c.invitationModal.form.label.role_hint')"
            name="role"
          />
        </form-field-set>

        <form-actions>
          <button-input
            :is-disabled="!isSaveable"
            @click="handleSubmit"
          >
            <font-awesome-icon icon="plus-circle" />
            {{ $t('c.invitationModal.form.action.submit') }}
          </button-input>
          <a
            v-t="'c.invitationModal.form.action.cancel'"
            class="cancel"
            @click="closeModal()"
          />
        </form-actions>
      </form-wrap>
    </modal>

  </div>
</template>

<script>
import uuid from 'uuid/v4'
import isBlank from 'is-blank'
import { mapActions, mapGetters, mapState } from 'vuex'
import FormMixin from '@/mixins/forms/Form'
import Modal from '@/components/ui/Modal'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

export default {
  name: 'InvitationMpdal',
  mixins: [FormMixin],
  components: {
    Modal,
    FontAwesomeIcon
  },
  computed: {
    ...mapGetters({
      fieldError: 'invitationForm/fieldError',
      isSaveable: 'invitationForm/isSaveable'
    }),
    requestType () {
      return 'create'
    },
    isVisible () {
      return this.$store.state.invitationModal.isVisible
    },
    isAdmin () {
      return this.role === 'admin' ? true : false
    },
    id: {
      get () { return this.$store.state.invitationForm.form.id },
      set (value) { this.$store.dispatch('invitationForm/setId', value) }
    },
    emailAddresses: {
      get () { return this.$store.state.invitationForm.form.emailAddresses },
      set (value) { this.$store.dispatch('invitationForm/setEmailAddresses', value) }
    },
    role: {
      get () {
        return this.$store.state.invitationForm.form.role == 'admin' ? true : false
      },
      set (value) { this.$store.dispatch('invitationForm/setRole', value) }
    }
  },
  methods: {
    ...mapActions({
      reset: 'invitationForm/reset',
      customSubmit: 'invitationForm/customSubmit',
      fetchInvitations: 'fetchUsers',
      closeModal: 'closeInvitationModal',
    }),
    handleSubmit () {
      this.customSubmit()
        .then(this.closeModal)
        .then(this.fetchUsers)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/invitations/InvitationModal.vue